module.exports = __webpack_public_path__ + "img/mic-records.d391eced.svg";